import { Popover } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Button, Div, Flex } from 'ui';
import { logout } from 'utils/cops-authenticator';
import LocaleToggle from '../../locale-toggle/containers/locale-toggle-container';
import HeaderButton from './header-button';
// eslint-disable-next-line max-len
import PlannerGroupToggle from '../../planner-group-toggle/components/planner-group-toggle';
// eslint-disable-next-line max-len
import ServiceCenterToggle from '../../service-center-toggle/containers/service-center-toggle-container';

const LogoutButton = styled(Button)`
  height: 25px !important;
  margin-top: 3px;
  margin-left: 10px;
  line-height: 1;
`;

const content = () =>
  <Div minWidth='200px'>
    <Flex marginBottom={10} fdc>
      <span>
        <FormattedMessage id='userManagement.CUSTOMER_CENTER' />
      </span>
      <ServiceCenterToggle />
    </Flex>
    <Flex marginBottom={10} fdc>
      <span>
        <FormattedMessage id='header.LANG' />
      </span>
      <LocaleToggle />
    </Flex>
    <Flex marginBottom={10} fdc>
      <span>
        <FormattedMessage id='header.PLANNERGROUP' />
      </span>
      <PlannerGroupToggle />
    </Flex>
  </Div>;

const userProfileTitle = () =>
  <Flex jcsb aic>
    <span><FormattedMessage id='common.titles.USER_PROFILE' /></span>
    <LogoutButton flat={1} onClick={logout}>
      <FormattedMessage id='header.LOGOUT' />
    </LogoutButton>
  </Flex>;

const UserProfileButton = ({ intl }) =>
  <Popover
    placement='bottomRight'
    content={content()}
    title={userProfileTitle()}
    trigger='click'
    overlayClassName='user-profile-popover'
    arrowPointAtCenter
    getPopupContainer={trigger => trigger.parentElement}
  >
    <HeaderButton
      light={true}
      icon='user'
      text={intl.formatMessage({ id: 'common.titles.USER_PROFILE' })}
    />
  </Popover>;

UserProfileButton.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(UserProfileButton);
